<template>
  <d-form @submit.prevent="submit" class="user-edit-email-form">
    <d-card class="mb-3">
      <d-card-body>
        <d-row>
          <d-col v-if="d_currentEmail" cols="12">
            <form-group :value="d_currentEmail" :label="$t('input.label.current_email')" :placeholder="$t('input.placeholder.current_email')" :readonly="true" type="email" />
          </d-col>

          <d-col cols="12">
            <form-group v-model="d_data.email" :error="d_mutation.errors.get('email')" :label="$t('input.label.new_email')" :placeholder="$t('input.placeholder.new_email')" type="email" />
          </d-col>
        </d-row>
      </d-card-body>
    </d-card>

    <div class="text-right mt-3">
      <r-button :error="d_mutation.error" :loading="d_mutation.loading" :success="d_mutation.success">
        {{ $t('button.save_changes') }}
      </r-button>

      <div v-if="d_mutation.errors.has('message')">
        {{ d_mutation.errors.get('message') }}
      </div>
    </div>
  </d-form>
</template>

<script>
import Mutation from '@/library/Mutation';

export default {
  name: 'user-email-form',
  data () {
    return {
      d_currentEmail: '',
      d_data: {},
      d_mutation: new Mutation(),
    };
  },
  created () {
    if (this.$oidc.userProfile && this.$oidc.userProfile.hasOwnProperty('email')) {
      this.d_currentEmail = this.$oidc.userProfile.email;
    }
  },
  methods: {
    submit () {
      this.d_mutation.reset();

      this.d_mutation.mutate(
        require('@/graphql/users/ChangeEmail.gql'),
        {
          newEmail: this.d_data.email,
        }
      ).then(() => {
        this.$emit('updateSuccess');
      });
    }
  }
}
</script>
